import { AnyCompanyPermissionType, AnyFacilityPermissionType } from '@shared/const'

type Params = {
  permission: AnyCompanyPermissionType | AnyFacilityPermissionType
  companyPermissions: string[]
  facilityPermissions: string[]
  enforceCompanyRoles: boolean | undefined
}
export const hasPermission = ({
  permission,
  companyPermissions,
  facilityPermissions,
  enforceCompanyRoles,
}: Params): boolean => {
  if (!enforceCompanyRoles) {
    return true
  }

  if (companyPermissions?.includes(permission) || facilityPermissions?.includes(permission)) {
    return true
  }

  return false
}
